import React from 'react'
import styled from 'styled-components'
import {
  SubscribeForNewsletterProps,
  SubscribeForNewsletterLabels,
} from './subscribeForNewsletter.props'
import { Copy, Heading, Typography } from '../Common'
import { useProfile, LocalLabelsProvider } from '@sentecacommerce-theme/lib'
import { Form } from './Components/Form'

export const SubscribeForNewsletter = ({
  title,
  newsletterBenefitsContent,
  newsletterBenefitsTitle,
  newsletterBenefitsImage,
  aboutNewsletterContent,
  aboutNewsletterTitle,
  formTitle,
  labels,
}: SubscribeForNewsletterProps) => {
  const { isLoading } = useProfile()

  return (
    <LocalLabelsProvider<SubscribeForNewsletterLabels> labels={labels}>
      <Container>
        <Heading as="h1" data={title} />
        <div className="mb-5">
          <Row>
            <div className="col-12 col-md-6">
              <Center>
                <img
                  loading="lazy"
                  src={newsletterBenefitsImage.url}
                  alt={newsletterBenefitsImage.alt}
                />
              </Center>
            </div>
            <div className="col-12 col-md-6">
              <Typography
                color="greyTitle"
                as="h2"
                variant="3"
                className="mb-4"
              >
                {newsletterBenefitsTitle}
              </Typography>
              <Copy html={newsletterBenefitsContent} />
            </div>
          </Row>
        </div>
        <Row>
          <Col>
            <Typography color="greyTitle" as="h2" variant="3" className="mb-4">
              {aboutNewsletterTitle}
            </Typography>
            <Copy html={aboutNewsletterContent} />
          </Col>
          <Col>
            <FormContainer>
              <Typography as="h2" variant="4" className="mb-2">
                {formTitle}
              </Typography>

              <Typography color="greyTitle" variant="7" className="mb-5">
                {labels?.requiredFields}
              </Typography>
              {!isLoading && <Form />}
            </FormContainer>
          </Col>
        </Row>
      </Container>
    </LocalLabelsProvider>
  )
}

const Container = styled.section.attrs({
  className: 'container',
})`
  & h1,
  h2 {
    font-weight: normal;
    line-height: 1.2;
  }
`

const Center = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})``

const Row = styled.section.attrs({
  className: 'row gx-5',
})``

const FormContainer = styled.div.attrs({
  className: 'p-5',
})`
  background: rgba(233, 245, 232, 0.3);
  border-radius: 0.4rem;
  box-shadow: 0.1rem 0.1rem 0.2rem #ccc;
`

const Col = styled.section.attrs({
  className: 'col-12 col-lg-6',
})``
